import React from 'react';
import Login from './Login';

const App: React.FC = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default App;
